import { render, staticRenderFns } from "./PowerMore.vue?vue&type=template&id=23c5914c&scoped=true&"
import script from "./PowerMore.vue?vue&type=script&lang=js&"
export * from "./PowerMore.vue?vue&type=script&lang=js&"
import style0 from "./PowerMore.vue?vue&type=style&index=0&id=23c5914c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5914c",
  null
  
)

export default component.exports